import * as React from 'react'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom';
import {VscContent, VscFullScreenContent} from "./ContentComponent";
import {
    VscButtonImageLayout,
    VscDefaultButton,
    VscDefaultImage,
    VscDefaultVideo,
    VscFlexRow,
    VscFlexRowLayout,
    VscImage,
    VscImageButton,
    VscLinkButton,
    VscSalesCenterLinkButton,
    VscSimpleLayout,
    VscVideoButton,
    VscWebButton
} from "./ButtonComponent";
import JsxParser from "react-jsx-parser";
import VscContentContext from './VscContentContext';
import {VscTitle} from "./VscTitle";
import {VscLots} from "./VscLots";
import {VscMarketHome} from "./VscMarketHome";
import {VscPlan} from "./VscPlan";
import VscAmenityMap from "./VscAmenityMap";
import VscSplashImage from "./VscSplashImage";
import ContentErrorBoundary from "../../errors/ContentErrorBoundary";
import VscError from "../../errors/VscError";
import {useIsAdmin} from "../../config";
import ContentRendererAdmin from "./ContentRendererAdmin";
import {ContentPageInfo} from "./ContentPageInfo";


export interface IVscVideo {
    type: "video",
    video: string,
    title:string;
}
export interface IVscWebPage {
    type: "web",
    url: string;
}
export type IVscMedia = IVscVideo | IVscWebPage;
export interface IVSCContextCallbacks {
    //onSetVideo(video:string, title:string, index:string): void;
    //onSetMedia(media:IVscMedia, value:string): void;
    setCurrentValue(val:string): void;
}
export interface IVscUrlSource {
    getNavigateContentUri(uri:string):string;

    getHtmlContentUri(uri:string):string;
    getHtmlControllerUri(uri:string):string;

    getVisualizerContentUri(url:string): string;
    getVisualizerControllerUri(url:string): string;


}
export class VscUrlSource implements IVscUrlSource {
    constructor(private readonly communityId:string|undefined, public readonly serverUri:string, private readonly contentUri:string) {}
    getNavigateContentUri(uri:string) {

        if (this.communityId) {
            return `/${this.communityId}/${uri}`;
        }
        return `/${uri}`;

    }
    getHtmlContentUri(uri:string) {
        return `${this.serverUri}${this.communityId ?? "sc"}/content/${uri}`

    }

    getHtmlControllerUri(uri:string) {
        return `${this.serverUri}${this.communityId ?? "sc"}/${uri}`
    }
    /**
     * These URLs are being used in the VISUALIZER
     * @param vscContext
     * @param url
     */
    getVisualizerContentUri(url:string) {
        return `${this.contentUri}${this.communityId ?? "sc"}/content/${url}`
    }

    /**
     * These URLs are being used in the VISUALIZER
     * @param vscContext
     * @param url
     */
    getVisualizerControllerUri(url:string) {
        if (!url.startsWith("/")) {
            return `${this.contentUri}${this.communityId ?? "sc"}/${url}`
        }
        else {

            const uri = new URL(this.contentUri);
            uri.pathname = "";
            return uri.toString() + url.substring(1); // remove preceding slash

        }
    }
}
export class VscContext extends VscUrlSource {

    constructor(serverUri: string, contentUri:string, communityId:string|undefined, public readonly callbacks: IVSCContextCallbacks) {
        super(communityId, serverUri, contentUri);
    }

    /**
     * sets which value is currently selected (i.e. what button is active)
     * @param val
     */
    setValue(val:string) {
        this.callbacks.setCurrentValue(val);
    }


}
const comps: any = {VscContent, VscLinkButton, VscVideoButton, VscSimpleLayout, VscImageButton,VscWebButton,
    VscImage,
    VscDefaultImage,
VscDefaultButton,
VscDefaultVideo,
    VscButtonImageLayout,
    VscFlexRowLayout,
    VscFlexRow,
    VscTitle,
    VscLots,
    VscMarketHome,
    VscPlan,
    VscAmenityMap,
    VscSplashImage,
    VscFullScreenContent,
    VscSalesCenterLinkButton
};

const MemoJsxParser = React.memo(JsxParser as any);
function getUri(serverUri:string, communityId?:string, contentPage?:string) {

    if (communityId === undefined) {
        //return `/content/${salesCenterId}/splash.jsx`;
        return `${serverUri}sc/content/splash.jsx`;

    }

    return `${serverUri}${communityId}/content/${contentPage ?? "index"}.jsx`;
    //return `/content/${salesCenterId}/${communityId}/${contentPage ?? "index"}.jsx`
}
const ContentRendererJSXPage: React.FC<{contentPage:string|undefined, communityId:string|undefined, salesCenterId:string, serverUri:string}> = ({contentPage, communityId, salesCenterId, serverUri}) => {
    const [error, setError] = useState<string|null>(null);
    const [content, setContent] = useState<ContentPageInfo|null>(null);
    const [contentOverride, setContentOverride] = useState<string|null>(null);
    const isAdmin = useIsAdmin();
    useEffect(() => {
        const uri = getUri(serverUri, communityId, contentPage);

        console.log(uri);
        fetch(uri).then(content => {
            if (!content.ok) {
                if (content.status === 404) {
                    throw new VscError("File not found");
                }
            }
            return content.text();
        }).then(content => setContent({content, contentPage: (contentPage ?? "index") }))
            .catch(err => {
                setError(err.message ?? err);
            });

    }, [contentPage, salesCenterId, communityId]);
    const onError = (args:any) => {
        setError(args.message);
    }

    const contentPageToUse = (contentPage ?? "index") + ".jsx";

    const contentToUse = contentOverride ?? content?.content ?? "";

    return <>
        { isAdmin && content !== null && contentPage !== undefined && <ContentRendererAdmin content={contentToUse} contentPage={contentPage} onUpdateContent={(contentUpdate:string|null) =>{
            setContentOverride(contentUpdate);
            setError(null);

        }} /> }
        <ContentErrorBoundary contentPage={contentPageToUse}>
        { error && <main>
            <h1>Error in markup {contentPage ?? "index"}.jsx</h1>
            <pre>
            { error }
            </pre></main>}
        {content &&
            <VscContentContext.Provider value={content.contentPage}>
                <MemoJsxParser jsx={contentToUse} key={contentOverride}
                               renderInWrapper={false}
                               onError={onError}
                               components={comps}
                />
            </VscContentContext.Provider>
        }
    </ContentErrorBoundary></>
}
const ContentRendererJSX : React.FC<{salesCenterId:string, serverUri:string}> = ({salesCenterId, serverUri}) => {
    const { contentPage, communityId } = useParams();
    return <ContentRendererJSXPage key={contentPage ?? "index"} contentPage={contentPage} communityId={communityId} salesCenterId={salesCenterId} serverUri={serverUri} />

}


export default ContentRendererJSX;